export const SUSSESS = {
    send_email_etax:"ดำเนินการเสร็จสิ้น"
}